import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { store } from "Store";
import { Row, Col, Card, Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { TextButton } from "Components/Button";
import { getUserFactors, setupUserSmsFactor, verifyLoggedInUserFactor, disableUserFactor } from "./SetMfaAxiosFuncs";
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { PageInfo } from "Components/PageInformation/PageInformation";
import { maskEMail } from "Utils/utilityFunctions";

const SetupMfa = () => {

  const dispatch = useDispatch();
  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;

  const [mfaUserInfo, setMfaUserInfo] = useState(null);
  const [newPhoneRequest, setNewPhoneRequest] = useState({
    mobileNumber: null
  });
  const [mfaToken, setMfaToken] = useState("");
  const [showSendCodeMsg, setShowSendCodeMsg] = useState(false);
  const [disableSendCode, setDisableSendCode] = useState(true);
  const [disableMfaTokenField, setDisableMfaTokenField] = useState(true);
  // error messages display on top 
  const [globalErrorList, setGlobalErrorList] = useState([]);
  const [showSMSMFASuccessMsg, setShowSMSMFASuccessMsg] = useState(null);
  const tokenInputRef = useRef();

  const [isSMSChecked, setIsSMSChecked] = useState(false);
  const [disableSMSSwitch, setDisableSMSSwitch] = useState(false);
  const [isEmailChecked, setIsEmailChecked] = useState(false);
  const [disableEmailSwitch, setDisableEmailSwitch] = useState(false);
  const [mfaVerificationInfo, setMfaVericationInfo] = useState({
    isSMSEnabled: false,
    isEmailEnabled: false,
    isSMSVerified: null,
    isEmailVerified: null
  });
  const [emailMfaToken, setEmailMfaToken] = useState("");
  // email error messages display on top 
  const [emailGlobalErrorList, setEmailGlobalErrorList] = useState([]);
  const [showEmailSendCodeMsg, setShowEmailSendCodeMsg] = useState(false);
  const [disableEmailSendCode, setDisableEmailSendCode] = useState(false);
  const [disableEmailMfaTokenField, setDisableEmailMfaTokenField] = useState(true);
  const [showEmailMFASuccessMsg, setShowEmailMFASuccessMsg] = useState(null);
  const [isInitialEmailMFAVerified, setIsInitialEmailMFAVerified] = useState(false);
  const emailTokenInputRef = useRef();


  // handle phone input field change
  const handlePhoneChange = (value) => {

    //console.log("print out phone change", value, value.length);

    // enable/disable "Send Code"
    if (value.length < 10) {
      setDisableSendCode(true);
    } else {
      setDisableSendCode(false);
    }

    setNewPhoneRequest({
      mobileNumber: value
    });
  }

  // api to send code with new phone number
  const handleSendCode = async () => {
    // clear error
    setGlobalErrorList([]);
    // disable the send code button to avoid double click renable it after 30s
    setDisableSendCode(true);
    // clear success msg
    setShowSMSMFASuccessMsg(null);

    const res = await setupUserSmsFactor(token, newPhoneRequest);

    //console.log("handleSendCode()", res);

    if (res && res.data.status !== 1) {
      setGlobalErrorList(res.data.globalErrorMessageList);
      setDisableSendCode(false);
    } else {
      setTimeout(() => {
        setDisableSendCode(false);
      }, 30000);
      setShowSendCodeMsg(true);
      setDisableMfaTokenField(false);
      setTimeout(() => {
        tokenInputRef.current.focus();
      }, 500);
      setMfaVericationInfo({
        ...mfaVerificationInfo,
        isSMSVerified: false
      });
      setMfaUserInfo({
        mobileNumber: null
      });
    }
  }

  // handle six digit mfa token field change
  const handleMfaChange = (e) => {

    let value = e.target.value;
    const regex = /^[0-9\b]+$/;

    //console.log("test mfa code", regex.test(value));

    if (value === '' || regex.test(value)) {
      setMfaToken(e.target.value);
    }
  }

  // api to verify the new phone device
  const verifyToken = async () => {
    // clear error
    setGlobalErrorList([]);
    setShowSendCodeMsg(false);

    //add the flag isinitialMFASetup into the api call 
    const res = await verifyLoggedInUserFactor(token, mfaToken, "SMS", isInitialEmailMFAVerified);

    //console.log("verifyToken", res, isInitialEmailMFAVerified);
    if (res && res.data.status !== 1) {
      setGlobalErrorList(res.data.globalErrorMessageList);
    } else {
      // update phone last 4 digit
      setMfaUserInfo({
        mobileNumber: newPhoneRequest?.mobileNumber?.slice(-4)
      });
      // display message on page instead of on popup and clean field
      setShowSMSMFASuccessMsg(res.data.message);
      setMfaVericationInfo({
        ...mfaVerificationInfo,
        isSMSVerified: true,
      });
      setNewPhoneRequest({
        mobileNumber: null
      });
      setMfaToken("");

      //enable the email mfa switch
      setDisableEmailSwitch(false);

    }
  }

  const handleSMSCheckChange = async () => {

    /** Switch management and the api integration */
    // if the user wants to enable the sms but the sms is not verified
    if (!isSMSChecked && mfaVerificationInfo.isSMSVerified === null) {
      setMfaVericationInfo({
        ...mfaVerificationInfo,
        isSMSVerified: false,
      })
    }

    // if the user wants to disable the sms but the sms is not verified
    if (!isSMSChecked === false && mfaVerificationInfo.isSMSVerified === false) {
      setMfaVericationInfo({
        ...mfaVerificationInfo,
        isSMSVerified: null,
      })
    }

    // if disable sms and email mfa is enabled and verified, then disable the email mfa switch
    if (!isSMSChecked === false && mfaVerificationInfo.isSMSVerified === true
      && isEmailChecked && mfaVerificationInfo.isEmailVerified === true
    ) {

      //calling api to disable the sms mfa and set sms mfa verified to null  
      const res = await disableUserFactor(token, "SMS");

      //console.log("disableUserFactor SMS", res);
      if (res && res.data.status !== 1) {
        setGlobalErrorList(res.data.globalErrorMessageList);
        return;
      } else {
        // disable sms mfa successfully
        setMfaVericationInfo({
          ...mfaVerificationInfo,
          isSMSVerified: null
        });

        //disable the email mfa switch, update the sms mfa switch, remove the last 4 digit phone
        setDisableEmailSwitch(true);
        setIsSMSChecked(!isSMSChecked);
        setMfaUserInfo({
          mobileNumber: null
        });
        return;
      }
    }

    if (!isSMSChecked === false) {
      setDisableSendCode(true);
    }

    setIsSMSChecked(!isSMSChecked);
    //clean previous message
    setShowSMSMFASuccessMsg(null);
    setGlobalErrorList([]);
    setShowSendCodeMsg(false);
    setNewPhoneRequest({
      mobileNumber: ""
    });
    setMfaToken("");
  }

  const handleEmailCheckChange = async () => {

    // if the user wants to enable the email but the email is not verified
    if (!isEmailChecked && mfaVerificationInfo.isEmailVerified === null) {
      setMfaVericationInfo({
        ...mfaVerificationInfo,
        isEmailVerified: false,
      })
    }

    // if the user wants to disable the email but the email is not verified
    if (!isEmailChecked === false && mfaVerificationInfo.isEmailVerified === false) {
      setMfaVericationInfo({
        ...mfaVerificationInfo,
        isEmailVerified: null,
      })
    }

    /** Switch management and the api integration */
    // if disable email and sms mfa is enabled and verified, then disable the sms mfa switch
    if (!isEmailChecked === false && mfaVerificationInfo.isEmailVerified === true
      && isSMSChecked && mfaVerificationInfo.isSMSVerified === true
    ) {

      const res = await disableUserFactor(token, "EMAIL");

      //console.log("disableUserFactor EMAIL", res);
      if (res && res.data.status !== 1) {
        setGlobalErrorList(res.data.globalErrorMessageList);
        return;
      } else {
        // disable email mfa successfully
        setMfaVericationInfo({
          ...mfaVerificationInfo,
          isEmailVerified: null
        });

        //disable the sms mfa switch, update the email mfa switch
        setDisableSMSSwitch(true);
        setIsEmailChecked(!isEmailChecked);
        return;
      }
    }

    if (!isEmailChecked === false) {
      setDisableEmailMfaTokenField(true);
    }

    setIsEmailChecked(!isEmailChecked);
    //clean previous message
    setShowEmailMFASuccessMsg(null);
    setEmailGlobalErrorList([]);
    setShowEmailSendCodeMsg(false);
    setEmailMfaToken("");
  }

  const handleEmailMfaChange = (e) => {
    let value = e.target.value;
    const regex = /^[0-9\b]+$/;

    //console.log("test mfa code", regex.test(value));

    if (value === '' || regex.test(value)) {
      setEmailMfaToken(e.target.value);
    }
  }

  // api to send code with new phone number
  const handleEmailSendCode = async () => {
    // clear error
    setEmailGlobalErrorList([]);
    // disable the send code button to avoid double click renable it after 30s
    setDisableEmailSendCode(true);
    // clear success msg
    setShowEmailMFASuccessMsg(null);

    // if no phone number provided, then send the token via the email
    const res = await setupUserSmsFactor(token, {
      mobileNumber: null
    });

    //console.log("handleEmailSendCode()", res);

    if (res && res.data.status !== 1) {
      setEmailGlobalErrorList(res.data.globalErrorMessageList);
      setDisableEmailSendCode(false);
    } else {
      setTimeout(() => {
        setDisableEmailSendCode(false);
      }, 30000);
      setShowEmailSendCodeMsg(true);
      setDisableEmailMfaTokenField(false);
      setTimeout(() => {
        emailTokenInputRef.current.focus();
      }, 500);
      setMfaVericationInfo({
        ...mfaVerificationInfo,
        isEmailVerified: false
      });
    }
  }

  // api to verify the email
  const verifyEmailToken = async () => {
    // clear error
    setEmailGlobalErrorList([]);
    setShowEmailSendCodeMsg(false);

    //console.log("verifyEmailToken() isInitialEmailMFAVerified", isInitialEmailMFAVerified);
    // add the flag isinitialMFASetup into the api call 
    const res = await verifyLoggedInUserFactor(token, emailMfaToken, "EMAIL", isInitialEmailMFAVerified);
    //console.log("verifyEmailToken", res);
    if (res && res.data.status !== 1) {
      setEmailGlobalErrorList(res.data.globalErrorMessageList);
    } else {
      setShowEmailMFASuccessMsg(res.data?.message);
      setMfaVericationInfo({
        ...mfaVerificationInfo,
        isEmailVerified: true,
      });
      setEmailMfaToken("");

      //enable the sms mfa switch
      setDisableSMSSwitch(false);
    }
  }

  // initial loading
  useEffect(() => {
    getUserFactors(token)
      .then((res) => {
        //console.log("getUserFactors()", res);
        if (res) {
          var statusCode = res.data.status;
          if (statusCode < 0) {
            statusCode = STATUSES.ERROR.code;
          }
          switch (statusCode) {
            case STATUSES.ERROR.code:
              if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
                setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: res.data.globalErrorMessageList,
                    showContactHelp: false
                  },
                  redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                  }
                })
              };
              break;
            case STATUSES.SUCCESS.code:

              const supportFactors = res.data.data?.supporteFactors;
              // system supported factors: SMS and EMAIL
              const isSMSEnabled = supportFactors.includes("SMS");
              const isEmailEnabled = supportFactors.includes("EMAIL");

              // not allowed to disable sms setting
              if (supportFactors.length === 1 && isSMSEnabled) {
                setDisableSMSSwitch(true);
              }

              // not allowed to disable email setting
              if (supportFactors.length === 1 && isEmailEnabled) {
                setDisableEmailSwitch(true);
              }

              let veriInfo = {
                isSMSEnabled: isSMSEnabled,
                isEmailEnabled: isEmailEnabled,
                isSMSVerified: null,
                isEmailVerified: null
              }

              // initial sms and email verification status and the UI switch disable status
              const uFactors = res.data.data?.userFactors;
              uFactors.forEach((item) => {
                if (item.factorType === 'EMAIL' && item.factorStatus === 1) {
                  veriInfo = {
                    ...veriInfo,
                    isEmailVerified: true
                  }

                  setIsEmailChecked(true);
                  if (uFactors.length === 1) {
                    setDisableEmailSwitch(true);
                  }

                  setIsInitialEmailMFAVerified(true);
                }
                if (item.factorType === 'SMS') {
                  // set last four digits mobile display
                  setMfaUserInfo({
                    mobileNumber: item.factorContent
                  });
                  if (item.factorStatus === 1) {
                    veriInfo = {
                      ...veriInfo,
                      isSMSVerified: true
                    }
                    setIsSMSChecked(true);
                    if (uFactors.length === 1) {
                      setDisableSMSSwitch(true);
                    }
                  }
                }
              });

              setMfaVericationInfo(veriInfo);
              break;
          }
        }
      }).catch((error) => {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      });
  }, []);


  // cancel the mfa email settings
  const cancelEmailMfa = () => {
    //clean previous operations
    setEmailMfaToken("");
    setShowEmailMFASuccessMsg(null);
    setShowEmailSendCodeMsg(false);
    setEmailGlobalErrorList([]);
  }

  // cancel SMS MFA
  const cancelMfa = () => {
    //clean previous operations
    setMfaToken("");
    setShowSendCodeMsg(false);
    setShowSMSMFASuccessMsg(null);
    setGlobalErrorList([]);
    setNewPhoneRequest({
      mobileNumber: ""
    });
    setDisableSendCode(true);
  }

  return (
    <Row>
      <Col xl={11} lg={11} md={11} sm={12}>
        <Card id="mfa-card" className="p-4">
          <Card.Body className="text-start">
            <h1 id="mainContent" className="header1 text-start mb-3 blue fw-bold">
              Two-Factor Authentication
            </h1>
            <p className="title-desc">
              To help protect your account, we support two methods of two-factor authentication (2FA): SMS and Email.
            </p>
            <p className="mb-4 title-desc">
              You may configure either or both authentication methods. At least one method must be set up before you can sign into the website.
            </p>
            {mfaVerificationInfo?.isSMSEnabled ?
              <>
                {/** SMS Settings Form */}
                <h2 className="mt-2 blue bold h2-form-title">
                  SMS Settings
                </h2>
                <Form className="mb-4">
                  <Form.Check
                    id="smsSettings"
                    type="switch"
                    label={
                      <div className="d-flex align-items-center">
                        {isSMSChecked ? "Enabled" : "Disabled"} {mfaVerificationInfo.isSMSVerified === null ?
                          null : mfaVerificationInfo.isSMSVerified ?
                            <span className="ms-2 verified-pill">Verified</span>
                            :
                            <span className="ms-2 unverified-pill">Unverified</span>
                        }
                      </div>}
                    checked={isSMSChecked}
                    disabled={disableSMSSwitch}
                    onChange={handleSMSCheckChange}
                  />
                  {isSMSChecked ?
                    <>
                      <p className="setting-info">
                        A verification code will be sent to your preferred phone number{mfaUserInfo?.mobileNumber ? <span className="mobile-last4"> ***-***-{mfaUserInfo?.mobileNumber}</span> : null}. Standard messaging rates apply.
                      </p>
                      {showSendCodeMsg ?
                        <>
                          <PageInfo className="mb-3" type="info" message={"A code has been sent to your registered cell phone. Please enter that code in the field below. You may send a new code after 30 seconds if needed."}></PageInfo>
                          <br />
                        </>
                        : null}
                      {showSMSMFASuccessMsg ?
                        <>
                          <PageInfo className="mb-3" type="success" message={showSMSMFASuccessMsg}></PageInfo>
                          <br />
                        </>
                        : null}
                      {globalErrorList.map((item, index) =>
                        <>
                          <PageInfo key={"errors_" + index} type="error" message={item}></PageInfo>
                          <br />
                        </>
                      )}
                      <Form.Group as={Row} className="mb-3" controlId="mfaPhone">
                        <Form.Label column sm="5" className="mfa-setting-label">
                          <div class="mfa-setting-step">
                            <span class="number">1.</span>
                            <span class="text">Enter a ten digit phone number.</span>
                          </div>
                        </Form.Label>
                        <Col xs={9} sm={3} className="mfa-setting-input">
                          <PhoneInput
                            defaultMask="(...) ...-...."
                            alwaysDefaultMask="true"
                            country={"us"}
                            autoFormat="true"
                            enableAreaCodes="true"
                            disableCountryCode="true"
                            disableDropdown="true"
                            disableSearchIcon="true"
                            disableCountryGuess="true"
                            buttonStyle={{ display: 'none' }}
                            inputClass={"form-control"}
                            placeholder={""}
                            inputProps={{
                              id: "mfaPhone"
                            }}
                            value={newPhoneRequest.mobileNumber}
                            onChange={handlePhoneChange}
                          />
                        </Col>
                      </Form.Group>
                      <Row className="mb-4 d-flex align-items-center">
                        <Col sm="5" className="pt-2 mfa-setting-label">
                          <div class="mfa-setting-step">
                            <span class="number">2.</span>
                            <span class="text">Click to send code to your registered mobile device.</span>
                          </div>
                        </Col>
                        <Col className="mfa-setting-input">
                          <TextButton
                            className="mt-1"
                            disabled={disableSendCode}
                            variant="normal"
                            onClick={handleSendCode}
                            content={"Send Code"}
                          >
                          </TextButton>
                        </Col>
                      </Row >
                      <Form.Group as={Row} className="mb-3" controlId="mfaToken">
                        <Form.Label column sm="5" className="mfa-setting-label">
                          <div class="mfa-setting-step">
                            <span class="number">3.</span>
                            <span class="text">Enter the six digit code.</span>
                          </div>
                        </Form.Label>
                        <Col xs={9} sm={3} id="smsTokenField" className="mfa-setting-input">
                          <Form.Control
                            ref={tokenInputRef}
                            disabled={disableMfaTokenField}
                            type="text"
                            maxlength={6}
                            value={mfaToken}
                            onChange={handleMfaChange}
                          />
                        </Col>
                      </Form.Group>
                      <Row className="mb-3 pt-1 d-flex align-items-center">
                        <Col sm="5" className="pt-2 mfa-setting-label">
                          <div class="mfa-setting-step">
                            <span class="number">4.</span>
                            <span class="text">Click Verify to confirm.</span>
                          </div>
                        </Col>
                        <Col className="mt-1 mfa-setting-input">
                          <TextButton
                            className="w-10 me-4"
                            variant="normal"
                            disabled={mfaToken.length !== 6}
                            onClick={verifyToken}
                            content={"Verify"}
                          >
                          </TextButton>
                          <TextButton
                            className="w-10"
                            variant="outline"
                            onClick={cancelMfa}
                            content={"Cancel"}
                          >
                          </TextButton>
                        </Col>
                      </Row>
                    </>
                    :
                    <p className="setting-info">
                      A verification code will be sent to your preferred phone number. Standard messaging rates apply.
                    </p>}
                </Form>
              </>
              : null
            }
            {mfaVerificationInfo?.isEmailEnabled ?
              <>
                {/** Email Settings Form*/}
                <h2 className="mt-2 blue bold h2-form-title">
                  Email Settings
                </h2>
                <Form className="mb-4">
                  <Form.Check
                    id="emailSettings"
                    type="switch"
                    label={
                      <div className="d-flex align-items-center">
                        {isEmailChecked ? "Enabled" : "Disabled"} {mfaVerificationInfo.isEmailVerified === null ?
                          null : mfaVerificationInfo.isEmailVerified ?
                            <span className="ms-2 verified-pill">Verified</span>
                            :
                            <span className="ms-2 unverified-pill">Unverified</span>
                        }
                      </div>}
                    checked={isEmailChecked}
                    disabled={disableEmailSwitch}
                    onChange={handleEmailCheckChange}
                  />
                  {showEmailMFASuccessMsg ? null :
                    <p className="setting-info">
                      A code will be sent to the email address associated with your account.
                    </p>}
                  {showEmailSendCodeMsg ?
                    <>
                      <PageInfo className="mb-3" type="info" message={"A code has been sent to the email address associated with your account. Please enter that code in the field below. It may take up to 2 minutes to receive this code. If you do not see the email after 2 minutes, please check your spam folder."}></PageInfo>
                      <br />
                    </>
                    : null}
                  {showEmailMFASuccessMsg ?
                    <>
                      <PageInfo className="mb-3" type="success" message={showEmailMFASuccessMsg}></PageInfo>
                      <br />
                    </>
                    : null}
                  {emailGlobalErrorList.map((item, index) =>
                    <>
                      <PageInfo key={"errors_" + index} type="error" message={item}></PageInfo>
                      <br />
                    </>
                  )}
                  {isEmailChecked &&
                    <>
                      <Row className="mb-4 d-flex align-items-center">
                        <Col sm="5" className="pt-2 mfa-setting-label">
                          <div class="mfa-setting-step">
                            <span>1.</span>
                            <span>Click to send code to <span className="email-label">{maskEMail(loginState?.username)}</span>.</span>
                          </div>
                        </Col>
                        <Col className="mfa-setting-input">
                          <TextButton
                            className="mt-1"
                            disabled={disableEmailSendCode}
                            variant="normal"
                            onClick={handleEmailSendCode}
                            content={"Send Code"}
                          >
                          </TextButton>
                        </Col>
                      </Row >
                      <Form.Group as={Row} className="mb-3" controlId="emailMfaToken">
                        <Form.Label column sm="5" className="mfa-setting-label">
                          <div class="mfa-setting-step">
                            <span class="number">2.</span>
                            <span class="text">Enter the six digit code.</span>
                          </div>
                        </Form.Label>
                        <Col xs={9} sm={3} id="emailTokenField" className="mfa-setting-input">
                          <Form.Control
                            ref={emailTokenInputRef}
                            disabled={disableEmailMfaTokenField}
                            type="text"
                            maxlength={6}
                            value={emailMfaToken}
                            onChange={handleEmailMfaChange}
                          />
                        </Col>
                      </Form.Group>
                      <Row className="mb-3 pt-1 d-flex align-items-center">
                        <Col sm="5" className="pt-2 mfa-setting-label">
                          <div class="mfa-setting-step">
                            <span class="number">3.</span>
                            <span class="text">Click Verify to confirm.</span>
                          </div>
                        </Col>
                        <Col className="mt-1 mfa-setting-input">
                          <TextButton
                            className="w-10 me-4"
                            variant="normal"
                            disabled={emailMfaToken.length !== 6}
                            onClick={verifyEmailToken}
                            content={"Verify"}
                          >
                          </TextButton>
                          <TextButton
                            className="w-10"
                            variant="outline"
                            onClick={cancelEmailMfa}
                            content={"Cancel"}
                          >
                          </TextButton>
                        </Col>
                      </Row>
                    </>
                  }
                </Form>
              </> : null}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default SetupMfa;